import React, {
  Fragment,
  useCallback,
  useEffect,
  useState,
} from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ValidationSchemaEmail } from "../../../conf/users";
import Request from "../../../core/requests";
import { useDispatch, useSelector } from "react-redux";
import {
  userDetailObjectErrorAction,
  userDetailObjectResetStateAction,
  userDetailSetObjectAction,
  userDetailUpdateObjectAction,
  userDetailGetObjectAction,
} from "../../../store/userDetail.store";
import { Loading } from "components/common";
import UpdateProfileForm from "forms/profile/UpdateProfileForm.component";
import { openSnackbar } from "store/slices/snackbar";
import ProfileCardComponent from "components/cards/profile/ProfileCard.component";
import { useTranslation } from "react-i18next";

const UpdateUserProfileContainer = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch();
  const { user, token } = useSelector((state) => state.user);
  const { loading, data, objectUpdated } = useSelector(
    (state) => state.userDetail
  );
  const [isSubmitting, setSubmitting] = useState(false);


  const updateForm = useCallback(() => {
    if (data) {
      setValue("email", data?.email);
      setValue("firstName", data?.firstName);
      setValue("lastName", data?.lastName);
    }
    // eslint-disable-next-line
  }, [data]);

  const { handleSubmit, control, formState, setValue } = useForm({
    resolver: yupResolver(ValidationSchemaEmail),
    defaultValues: {
      email: "",
      firstName: "",
      lastName: "",
    },
  });

  const onSuccess = useCallback(() => {
    setSubmitting(true);
    dispatch(
      openSnackbar({
        open: true,
        message: "Profilo aggiornato con successo",
        variant: "alert",
        alert: {
          color: "success",
        },
        close: false,
      })
    );
    // eslint-disable-next-line
  }, []);

  const onSubmit = useCallback((data) => {
    const values = data;
    const endpoint = Request.users.updateUserDetail;
    const setAction = userDetailSetObjectAction;
    const errorAction = userDetailObjectErrorAction;
    const id = user.userId;
    dispatch(
      userDetailUpdateObjectAction({
        id,
        token,
        values,
        endpoint,
        setAction,
        errorAction,
      })
    );
    // eslint-disable-next-line
  }, [token]);

  useEffect(() => {
    return () => {
      dispatch(userDetailObjectResetStateAction());
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const endpoint = Request.users.getUserDetail;
    const setAction = userDetailSetObjectAction;
    const errorAction = userDetailObjectErrorAction;
    const id = user.userId;
    dispatch(
      userDetailGetObjectAction({ id, token, endpoint, setAction, errorAction })
    );
    // eslint-disable-next-line
  }, [objectUpdated, token]);

  useEffect(() => {
    updateForm();
    // eslint-disable-next-line
  }, [data]);

  useEffect(() => {
    if (objectUpdated) onSuccess();
    // eslint-disable-next-line
  }, [objectUpdated]);

  return (
    <Fragment>
      {loading ? (
        <Loading />
      ) : (
        <Fragment>
          <ProfileCardComponent data={data} />

          <UpdateProfileForm
            errors={formState.errors}
            control={control}
            isSubmitting={isSubmitting}
            handleSubmit={handleSubmit(onSubmit)}
            labelButton={t('Edit')}
          />
        </Fragment>
      )}
    </Fragment>
  );
};

export default UpdateUserProfileContainer;
